module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }